"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteProductStatus = exports.QuoteProductStore = void 0;
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var Types_2 = require("ContentTokens/Models/inputs/Types");
var inversify_1 = require("inversify");
var mobx_1 = require("mobx");
var TokenSearchService_1 = __importDefault(require("Project/Actions/Tokens/Search/TokenSearchService"));
var ProjectStore_1 = __importDefault(require("Project/Stores/ProjectStore"));
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
var ProductStaticWellKnownMapping_1 = require("@CommonFrontendBackend/QuoteV2/ProductStaticWellKnownMapping");
var QuoteProductStatus;
(function (QuoteProductStatus) {
    QuoteProductStatus["Loading"] = "loading";
    QuoteProductStatus["Available"] = "available";
    QuoteProductStatus["Unavailable"] = "unavailable";
})(QuoteProductStatus || (QuoteProductStatus = {}));
exports.QuoteProductStatus = QuoteProductStatus;
var QuoteProductStore = (function () {
    function QuoteProductStore(projectStore, usingFeature, tokenSearchService) {
        var _this = this;
        this.projectStore = projectStore;
        this.usingFeature = usingFeature;
        this.tokenSearchService = tokenSearchService;
        this._status = QuoteProductStatus.Loading;
        this._productToken = undefined;
        this._productTokenObjectType = undefined;
        this._fetchedProductTokenItemProperties = undefined;
        this._productTokenItemProperties = { status: FetchUtils_1.RemoteDataStatus.NotRequested };
        this.getFilteredTokens = function () { return __awaiter(_this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.tokenSearchService.createSearchFn(this._productToken)({
                            dataType: this._productToken.substitutionToken.dataType,
                        })];
                    case 1: return [2, (_a.sent()).filter(function (itemProperty) {
                            var _a, _b;
                            return ((_a = itemProperty.hierarchyInfo) === null || _a === void 0 ? void 0 : _a.parentId) === ((_b = _this._productToken.substitutionToken) === null || _b === void 0 ? void 0 : _b.id) ||
                                itemProperty.objectType === _this._productToken.childObjectType;
                        })];
                }
            });
        }); };
        this.disposeAutorunner = (0, mobx_1.autorun)(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, productToken;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.projectStore.isCrmTemplate) {
                            this._status = QuoteProductStatus.Unavailable;
                            return [2];
                        }
                        this._status = QuoteProductStatus.Loading;
                        return [4, tokenSearchService.searchAllTokens({
                                searchTerm: "products",
                            })];
                    case 1:
                        result = _a.sent();
                        productToken = result.find(function (token) { return token.dataType === Types_1.TokenDataType.ProductList; });
                        (0, mobx_1.runInAction)(function () { return __awaiter(_this, void 0, void 0, function () {
                            var itemProperties_1, error_1;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this._status = !!productToken ? QuoteProductStatus.Loading : QuoteProductStatus.Unavailable;
                                        if (!productToken) return [3, 5];
                                        this._productToken = new Types_2.RepeatingTokenInput(productToken.apiName, productToken.name, productToken.childObjectType, productToken.childPropertyLabel, SubstitutionTokenFactory_1.default.fromLegacyApiToken(productToken));
                                        this._productTokenObjectType = productToken.objectType;
                                        this._productTokenItemProperties = { status: FetchUtils_1.RemoteDataStatus.Loading };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4, this.getFilteredTokens()];
                                    case 2:
                                        itemProperties_1 = _a.sent();
                                        if (ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.hasAllProperties(this._productToken.substitutionToken.id, itemProperties_1)) {
                                            this._status = QuoteProductStatus.Available;
                                            (0, mobx_1.runInAction)(function () {
                                                _this._fetchedProductTokenItemProperties = itemProperties_1;
                                                _this._productTokenItemProperties = {
                                                    status: FetchUtils_1.RemoteDataStatus.Success,
                                                    data: itemProperties_1.map(function (itemProperty) {
                                                        return new Types_2.TokenInput(itemProperty.apiName, itemProperty.name, SubstitutionTokenFactory_1.default.fromLegacyApiToken(itemProperty));
                                                    }),
                                                };
                                            });
                                        }
                                        else {
                                            this._status = QuoteProductStatus.Unavailable;
                                        }
                                        return [3, 4];
                                    case 3:
                                        error_1 = _a.sent();
                                        (0, mobx_1.runInAction)(function () {
                                            _this._productTokenItemProperties = { status: FetchUtils_1.RemoteDataStatus.Error, error: error_1 };
                                        });
                                        return [3, 4];
                                    case 4: return [3, 6];
                                    case 5:
                                        this._productToken = undefined;
                                        _a.label = 6;
                                    case 6: return [2];
                                }
                            });
                        }); });
                        return [2];
                }
            });
        }); });
    }
    QuoteProductStore.prototype.unbind = function () {
        var _a;
        (_a = this.disposeAutorunner) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    Object.defineProperty(QuoteProductStore.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductStore.prototype, "productToken", {
        get: function () {
            return this._productToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductStore.prototype, "objectType", {
        get: function () {
            return this._productTokenObjectType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductStore.prototype, "fetchedProductTokenItemProperties", {
        get: function () {
            return this._fetchedProductTokenItemProperties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteProductStore.prototype, "productTokenItemProperties", {
        get: function () {
            return this._productTokenItemProperties;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], QuoteProductStore.prototype, "_status", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], QuoteProductStore.prototype, "_fetchedProductTokenItemProperties", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _a : Object)
    ], QuoteProductStore.prototype, "_productTokenItemProperties", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], QuoteProductStore.prototype, "status", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], QuoteProductStore.prototype, "fetchedProductTokenItemProperties", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof FetchUtils_1.RemoteData !== "undefined" && FetchUtils_1.RemoteData) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], QuoteProductStore.prototype, "productTokenItemProperties", null);
    QuoteProductStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)("projectStore")),
        __param(1, (0, inversify_1.inject)("usingFeature")),
        __param(2, (0, inversify_1.inject)("tokenSearchService")),
        __metadata("design:paramtypes", [typeof (_c = typeof ProjectStore_1.default !== "undefined" && ProjectStore_1.default) === "function" ? _c : Object, typeof (_d = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _d : Object, typeof (_e = typeof TokenSearchService_1.default !== "undefined" && TokenSearchService_1.default) === "function" ? _e : Object])
    ], QuoteProductStore);
    return QuoteProductStore;
}());
exports.QuoteProductStore = QuoteProductStore;
